module.exports = __webpack_public_path__ + "img/5_6.614b8f39.png";